import produce from "immer";
import {
  FETCH_NEWS,
  FETCH_NEWS_SUCCESS,
  FETCH_NEWS_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_NEWS,
  ADD_NEWS_SUCCESS,
  ADD_NEWS_FAILURE,
  //
  EDIT_NEWS,
  EDIT_NEWS_SUCCESS,
  EDIT_NEWS_FAILURE,
  //
  DELETE_NEWS,
  DELETE_NEWS_SUCCESS,
  DELETE_NEWS_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingNews: false,
  News: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentNews: {},
  // Delete
  isDeleting: false,
};

const NewsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_NEWS:
        draft.isFetchingNews = true;
        draft.currentNews = {};
        break;
      case FETCH_NEWS_SUCCESS:
        draft.isFetchingNews = false;
        draft.News = action.payload;
        break;
      case FETCH_NEWS_FAILURE:
        draft.isFetchingNews = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentNews = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentNews = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_NEWS:
        draft.isSubmitting = true;
        break;
      case ADD_NEWS_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_NEWS_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_NEWS:
        draft.isSubmitting = true;
        break;
      case EDIT_NEWS_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_NEWS_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_NEWS:
        draft.isDeleting = true;
        break;
      case DELETE_NEWS_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_NEWS_FAILURE:
        draft.isDeleting = false;
        break;

      default:
        return state;
    }
  });

export default NewsReducer;
